// extracted by css-extract-rspack-plugin
export default {"badge":"badge-vTNfbJ","success":"success-A7SRWv","danger":"danger-cNpLwk","warning":"warning-GjB9nO","info":"info-vX4lfg","secondary":"secondary-uI7Jcq"};